(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    if (!window.hdtCardSizesInit) {
    window.hdtCardSizesInit = true;

    var TXT_ADDED = 'A\u00f1adido \u2713';
    var TXT_ERROR = 'Error';
    var TXT_NO_STOCK = 'Sin stock';

    var getDrawer = function () {
      return document.querySelector('cart-drawer');
    };

    /* Reemplaza el contenido del cart drawer con el HTML nuevo de la seccion */
    var renderDrawer = function (drawer, html) {
      if (!drawer || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshDrawer = doc.querySelector('cart-drawer');
      if (!freshDrawer) return;

      var dialog = drawer.querySelector('#CartDrawer');
      var freshDialog = freshDrawer.querySelector('#CartDrawer');
      if (!dialog || !freshDialog) return;

      ['is-empty', 'hdt-dialog-drawer--cart-message'].forEach(function (cls) {
        dialog.classList.toggle(cls, freshDialog.classList.contains(cls));
      });

      var inner = dialog.querySelector('.hdt-drawer__inner');
      var freshInner = freshDialog.querySelector('.hdt-drawer__inner');
      if (inner && freshInner) {
        inner.replaceWith(document.importNode(freshInner, true));
      }

      var count = freshDrawer.getAttribute('data-count');
      if (count !== null) {
        drawer.setAttribute('data-count', count);
        updateCounters(drawer, count);
      }
    };

    /* Actualiza los numeritos del carrito en el header */
    var updateCounters = function (drawer, count) {
      var selectors = '[data-cart-count], .hdt-cart-count, [class*="cart-count"], [class*="cart_count"], [id*="cart-count" i]';
      document.querySelectorAll(selectors).forEach(function (el) {
        if (drawer && drawer.contains(el)) return;
        if (el.children.length === 0) el.textContent = count;
        if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', count);
        if (el.hasAttribute('data-count')) el.setAttribute('data-count', count);
      });
    };

    /* Abre el drawer usando el boton del carrito del header */
    var openDrawer = function (drawer) {
      if (!drawer) return;
      var dialog = drawer.querySelector('#CartDrawer');
      if (dialog && dialog.open) return;

      var triggers = Array.prototype.filter.call(
        document.querySelectorAll('[aria-controls="CartDrawer"]'),
        function (el) { return !drawer.contains(el); }
      );
      var visible = triggers.filter(function (el) { return el.offsetParent !== null; });
      var trigger = visible[0] || triggers[0];
      if (trigger) trigger.click();

      /* Respaldo si el tema no lo abrio con el clic */
      setTimeout(function () {
        if (!dialog || dialog.open) return;
        if (typeof drawer.open === 'function') drawer.open();
        else if (typeof drawer.show === 'function') drawer.show();
        else if (typeof dialog.showModal === 'function') dialog.showModal();
      }, 200);
    };

    /* Anade al carrito, actualiza el drawer. Devuelve { ok, message } */
    var addToCart = async function (variantId) {
      var drawer = getDrawer();
      var sectionId = drawer ? drawer.getAttribute('section-id') : null;
      var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sectionId) {
        payload.sections = [sectionId];
        payload.sections_url = window.location.pathname;
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      var data = await response.json();
      if (!response.ok) return { ok: false, message: data.description || TXT_NO_STOCK };

      if (drawer && data.sections && data.sections[sectionId]) {
        renderDrawer(drawer, data.sections[sectionId]);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
      return { ok: true, drawer: drawer };
    };

    /* ---------- Escritorio: franja al pasar el mouse ---------- */
    document.addEventListener('submit', async function (event) {
      var form = event.target.closest('[data-card-size-form]');
      var button = event.submitter;
      if (!form || !button || !button.value) return;

      event.preventDefault();
      var label = form.querySelector('[data-card-size-label]');
      var originalText = label.textContent;
      form.classList.add('is-loading');

      try {
        var result = await addToCart(button.value);
        if (result.ok) {
          label.textContent = TXT_ADDED;
          openDrawer(result.drawer);
        } else {
          label.textContent = result.message;
        }
      } catch (error) {
        console.warn('Error al a\u00f1adir al carrito', error);
        label.textContent = TXT_ERROR;
      } finally {
        form.classList.remove('is-loading');
        setTimeout(function () { label.textContent = originalText; }, 2000);
      }
    });

    /* ---------- Movil: boton + y panel desplegable ---------- */
    var sheet = null;

    var buildSheet = function () {
      sheet = document.createElement('div');
      sheet.className = 'hdt-size-sheet';
      sheet.innerHTML =
        '<div class="hdt-size-sheet__overlay" data-sheet-close></div>' +
        '<div class="hdt-size-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="hdtSizeSheetTitle">' +
          '<div class="hdt-size-sheet__header">' +
            '<p class="hdt-size-sheet__title" id="hdtSizeSheetTitle"></p>' +
            '<button type="button" class="hdt-size-sheet__close" data-sheet-close aria-label="Cerrar">' +
              '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="hdt-size-sheet__list" role="list"></div>' +
          '<p class="hdt-size-sheet__msg" role="status"></p>' +
        '</div>';
      document.body.appendChild(sheet);

      sheet.addEventListener('click', async function (event) {
        if (event.target.closest('[data-sheet-close]')) {
          closeSheet();
          return;
        }
        var item = event.target.closest('[data-sheet-variant]');
        if (!item || item.disabled) return;

        var msg = sheet.querySelector('.hdt-size-sheet__msg');
        msg.textContent = '';
        sheet.classList.add('is-loading');
        try {
          var result = await addToCart(item.getAttribute('data-sheet-variant'));
          if (result.ok) {
            closeSheet();
            setTimeout(function () { openDrawer(result.drawer); }, 250);
          } else {
            msg.textContent = result.message;
          }
        } catch (error) {
          console.warn('Error al a\u00f1adir al carrito', error);
          msg.textContent = TXT_ERROR;
        } finally {
          sheet.classList.remove('is-loading');
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
      });
    };

    var escapeHtml = function (text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    };

    var openSheet = function (form) {
      if (!sheet) buildSheet();
      sheet.querySelector('.hdt-size-sheet__title').textContent = form.getAttribute('data-title') || '';
      sheet.querySelector('.hdt-size-sheet__msg').textContent = '';

      var html = '';
      form.querySelectorAll('.hdt-card-sizes__item').forEach(function (btn) {
        var name = escapeHtml(btn.textContent.trim());
        if (btn.disabled) {
          html += '<button type="button" role="listitem" class="hdt-size-sheet__item" disabled>' + name + '</button>';
        } else {
          html += '<button type="button" role="listitem" class="hdt-size-sheet__item" data-sheet-variant="' + btn.value + '">' + name +
            (btn.hasAttribute('data-low') ? '<small>\u00dalt. unids</small>' : '') + '</button>';
        }
      });
      sheet.querySelector('.hdt-size-sheet__list').innerHTML = html;

      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      var close = sheet.querySelector('.hdt-size-sheet__close');
      setTimeout(function () { close.focus({ preventScroll: true }); }, 50);
    };

    var closeSheet = function () {
      if (!sheet) return;
      sheet.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    };

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-card-sizes-open]');
      if (!toggle) return;
      event.preventDefault();
      event.stopPropagation();
      var form = toggle.parentElement.querySelector('[data-card-size-form]');
      if (form) openSheet(form);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
